<cam-loader [isLoading]="true"></cam-loader>
